// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__18v25","amount":"Amount_amount__1XKRR","tip":"Amount_tip__8dN7F","tipHeader":"Amount_tipHeader__iiA0G","tipsWrap":"Amount_tipsWrap__32-yZ"};